import { Grid, Typography } from '@mui/material';
import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import RootineButton from '../../atoms/RootineButton';
import { ArrowBack } from '@mui/icons-material';

export interface MissingResultsProps {
  head: string;
  subhead: string;
  buttonLabel: string;
  buttonLink: string;
  foot: string;
  footLink: string;
  height?: number;
  useFootIcon?: boolean;
}

export const MissingResults = (props: MissingResultsProps): JSX.Element => {
  const {
    height,
    head,
    subhead,
    buttonLabel,
    buttonLink,
    foot,
    footLink,
    useFootIcon = true,
  } = props;
  return (
    <Grid
      item
      container
      direction="row"
      display="flex"
      alignItems="center"
      sx={{
        height: height ? height + 'vh' : '100vh',
      }}
    >
      <Grid item container rowSpacing={2} xs={12} sx={{ textAlign: 'center' }}>
        <Grid item xs={12}>
          <Typography fontSize={16}>
            <LockIcon sx={{ position: 'relative', top: 4 }} />
            {head}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography fontSize={14}>{subhead}</Typography>
        </Grid>

        <Grid item xs={12}>
          <RootineButton
            variation="primary"
            label={buttonLabel}
            href={buttonLink}
            size="medium"
            hideIcon
          />
        </Grid>

        <Grid item xs={12}>
          <RootineButton
            variation="plain"
            hideIcon
            size="medium"
            onClick={() => (window.location.href = footLink)}
            label={foot}
            startIcon={useFootIcon ? <ArrowBack /> : undefined}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
